window.addEventListener('alpine:init', bootstrap);

export default () => ({
	$header: null,
	header_visible: true,
	expanded: false,
	init() {
		this.$header = document.getElementById('site-header');
		this.setHeight();
	},
	setHeight() {
		let height = 0;
		if ( this.header_visible ) {
			height = this.$header.clientHeight;
		}
		document.body.style.setProperty('--header-height', height + 'px');
	}
});

function bootstrap() {
	const $main = document.getElementById('main');
	if ( !$main ) { return; }

	$main.setAttribute('x-data', 'headerSpace');
	$main.setAttribute('x-on:resize.window.debounce.100ms', 'setHeight');
	$main.setAttribute('x-on:resize.window.throttle.100ms', 'setHeight');
}


